import { appStore } from "../../Orchestrator/Recoils/store";
import { manageIncludeWidgetsAtom } from "../../Orchestrator/Recoils/MyAccount";
import { IManageWidgetItem } from "../../Orchestrator/Types/Interface/IWidgetsReqAndRes";

/**
 * Returns true when the widget identified by `key` is in the
 * user's enabled widget list (manageIncludeWidgetsAtom).
 *
 * Used to gate widget data fetches so we don't hit the API
 * for widgets the user has turned off.
 */
export function isWidgetEnabled(key: string): boolean {
    const widgets: IManageWidgetItem[] = appStore.get(manageIncludeWidgetsAtom) || [];
    return widgets.some((w) => w.key === key);
}
